import {BookOpenIcon} from 'lucide-react';
import {useTranslation} from 'react-i18next';
import {Button, type ButtonProps} from '../button';

export type LearnMoreButtonProps = Omit<ButtonProps, 'children'> & {
  label?: string;
};

export function LearnMoreButton({label, ...props}: LearnMoreButtonProps) {
  const {t} = useTranslation();

  return (
    <Button variant="link" {...props}>
      <BookOpenIcon className="size-5 text-[var(--button-link-text)]" />
      {label || t('learn_more')}
    </Button>
  );
}
